<template>
  <div>
    <h1>Automatický plánovač checkpointů</h1>
    <div>
      <div class="asd-layout m-3">
        <div class="asd-input-pair">
          <label for="plan-start"> Začátek plánu </label>
          <input id="plan-start"
                 v-model="start"
                 type="datetime-local"
                 class="asd-input"
          />
        </div>
        <div class="asd-input-pair">
          <label for="plan-end"> Konec plánu </label>
          <input id="plan-end"
                 v-model="end"
                 type="datetime-local"
                 class="asd-input"
          />
        </div>
        <div class="asd-input-pair">
          <label for="steps-amount"> Počet bodů </label>
          <input id="steps-amount"
                 v-model="stepsAmount"
                 type="number"
                 class="asd-input"
                 min="1"
                 max="20"
          />
        </div>
        <div class="asd-input-pair">
          <label for="include-start"> Včetně začátku </label>
          <input id="include-start"
                 v-model="includeStart"
                 type="checkbox"
                 class="asd-input"
          />
        </div>
        <div class="asd-input-pair">
          <label for="include-end"> Včetně konce </label>
          <input id="include-end"
                 v-model="includeEnd"
                 type="checkbox"
                 class="asd-input"
          />
        </div>
        <div class="asd-input-pair">
          <button class="asd-btn-confirm"
                  @click="recalculate"
          >
            <i v-help.mouse="`Přepočítat checkpointy`"
               class="fas fa-sync"
            ></i>
          </button>
        </div>
      </div>
      <table class="asd-table">
        <thead>
          <tr class="table-heading">
            <th>Datum</th>
            <th>Název</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(c, i) in checkpointsTable"
              :key="`${i}-checkpoint`"
          >
            <td>{{ c.date }}</td>
            <td>{{ c.name }}</td>
          </tr>
        </tbody>
      </table>
      <div style="margin: 10px">
        <button class="asd-btn-confirm"
                @click="create"
        >
          <i v-help.mouse="`Založit checkpointy`"
             class="fas fa-save"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EntityQuery from 'CORE/utils/entity-query'
import { get, map } from 'lodash'
import moment from 'CORE/utils/moment-ext'
import EventBus from 'CORE/bus'
import axios from 'axios'
import { DATE_TIME_FORMAT } from 'CORE/utils/date'

export default {
    name: 'CheckpointsPlanner',
    components: {},
    props: {
        entity: {
            type: String,
            required: true,
            default: () => null,
        },
    },
    data() {
        return {
            start: null,
            end: null,
            stepsAmount: 4,
            checkpoints: [],
            includeStart: false,
            includeEnd: true,
        }
    },
    computed: {
        project() {
            return this.$store.getters.getProjectById(this.entity)
        },
        projectStart() {
            const q = new EntityQuery(this.$store)
            const str = q.onePropertyByTag(this.project, 'startTime')
            return str.singleValue
        },
        projectEnd() {
            const q = new EntityQuery(this.$store)
            const str = q.onePropertyByTag(this.project, 'endTime')
            return str.singleValue
        },
        checkpointsTable() {
            return map(this.checkpoints, ch => {
                return {
                    date: moment(get(ch, 'timestamp'), 'X').format(DATE_TIME_FORMAT),
                    name: get(ch, 'name'),
                }
            })
        },
    },
    mounted() {
        const q = new EntityQuery(this.$store)
        const startTime = get(q.onePropertyByTag(this.project, 'startTime'), 'singleValue')
        if (startTime) {
            this.start = moment(startTime, 'X').add(1, 'weeks').toISOString(true).substr(0, 19)
        }
        const endTime = get(q.onePropertyByTag(this.project, 'endTime'), 'singleValue')
        if (endTime) {
            this.end = moment(endTime, 'X').add(1, 'weeks').toISOString(true).substr(0, 19)
        }
    },
    methods: {
        toDate(timestamp) {
            return moment(timestamp, 'X').toISOString()
        },
        async create() {
            for (const cp of this.checkpoints) {
                cp.entity_id = this.entity
                await axios.post(`/workflow/checkpoints/add`, cp)
            }
            this.$emit('done')
        },
        async recalculate() {
            const startTime = moment(this.start)
            const endTime = moment(this.end)

            const startSeconds = startTime.unix()
            const endSeconds = endTime.unix()

            try {
                const data = {
                    startSeconds,
                    endSeconds,
                    stepsAmount: parseInt(this.stepsAmount),
                    includeStart: this.includeStart,
                    includeEnd: this.includeEnd,
                }
                this.checkpoints = get(await axios.post(`/workflow/checkpoints/make-a-plan`, data), 'data')
            } catch (e) {
                EventBus.$emit('FLASH_USER_ERROR', { message: e })
            }
        },
    },
}
</script>

<style lang="scss">
.asd-layout {
    display: flex;
    .asd-input-pair {
        display: flex;
        margin: 3px;
        flex-direction: column;
        label {
            text-align: left;
            margin: 0 auto 0px 5px;
            font-weight: bold;
            color: var(--color-primary);
        }
    }
}
.m-3 {
    margin: 3rem;
}
</style>
